export default __webpack_public_path__ + "media/Left_chat.bd21d556.svg";